webpackJsonp([79611799117203,60335399758886],{

/***/ 120:
/***/ (function(module, exports) {

	module.exports = {
		"layoutContext": {}
	};

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(245);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(120);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 339:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 340:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(15);
	
	var _SiteConfig = __webpack_require__(16);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	__webpack_require__(339);
	
	__webpack_require__(340);
	
	var _theme = __webpack_require__(246);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainLayout = function (_React$Component) {
	  _inherits(MainLayout, _React$Component);
	
	  function MainLayout() {
	    _classCallCheck(this, MainLayout);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  MainLayout.prototype.getLocalTitle = function getLocalTitle() {
	    function capitalize(string) {
	      return string.charAt(0).toUpperCase() + string.slice(1);
	    }
	    var pathPrefix = _SiteConfig2.default.pathPrefix ? _SiteConfig2.default.pathPrefix : '/';
	    var currentPath = this.props.location.pathname.replace(pathPrefix, '').replace('/', '');
	    var title = '';
	    if (currentPath === '') {
	      title = 'Home';
	    } else if (currentPath === 'tags/') {
	      title = 'Tags';
	    } else if (currentPath === 'categories/') {
	      title = 'Categories';
	    } else if (currentPath === 'about/') {
	      title = 'About';
	    } else if (currentPath.includes('posts')) {
	      title = 'Article';
	    } else if (currentPath.includes('tags/')) {
	      var tag = currentPath.replace('tags/', '').replace('/', '').replace('-', ' ');
	      title = 'Tagged in ' + capitalize(tag);
	    } else if (currentPath.includes('categories/')) {
	      var category = currentPath.replace('categories/', '').replace('/', '').replace('-', ' ');
	      title = '' + capitalize(category);
	    }
	    return title;
	  };
	
	  MainLayout.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          _SiteConfig2.default.siteTitle + ' |  ' + this.getLocalTitle()
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: _SiteConfig2.default.siteDescription })
	      ),
	      _react2.default.createElement(
	        _styledComponents.ThemeProvider,
	        { theme: _theme2.default },
	        children()
	      )
	    );
	  };
	
	  return MainLayout;
	}(_react2.default.Component);
	
	exports.default = MainLayout;
	module.exports = exports['default'];

/***/ }),

/***/ 246:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var theme = {
	  // named colors:
	  brand: '#41B883',
	  accent: '#0a5eb7',
	  accentDark: '#35495E',
	  lightGrey: '#F6F6F6',
	  darkGrey: '#91a2a3',
	  ink: 'black',
	  errorRed: '#FF6666',
	  codeEditBlue: '#2973b7',
	  codeEditGreen: '#42b983',
	
	  // content width:
	  contentWidthLaptop: '850px',
	  sitePadding: '25px'
	};
	
	exports.default = theme;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-jsx-594f99b1bee9808e8102.js